const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-list-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 16H15",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M12 12H15",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M9 12H9.01",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M9 16H9.01",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_5",
    d: "M8 5V5C7.06812 5 6.60218 5 6.23463 5.15224C5.74458 5.35523 5.35523 5.74458 5.15224 6.23463C5 6.60218 5 7.06812 5 8V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8C19 7.06812 19 6.60218 18.8478 6.23463C18.6448 5.74458 18.2554 5.35523 17.7654 5.15224C17.3978 5 16.9319 5 16 5V5",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_6",
    d: "M8 4.70711V7H16V4.70711C16 4.25435 15.8201 3.82014 15.5 3.5C15.1799 3.17986 14.7456 3 14.2929 3H9.70711C9.25435 3 8.82014 3.17986 8.5 3.5C8.17986 3.82014 8 4.25435 8 4.70711Z",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTerms);
export default __webpack_public_path__ + "static/media/icon_terms.996fe7daa9e16e516aaaaaa3e40e96a1.svg";
export { ForwardRef as ReactComponent };